import { useReducer, useEffect, useState } from 'react';
// import { get } from 'axios'; // ❌ Se comenta: importación incorrecta en nuevas versiones de axios
import axios from 'axios'; // ✅ Nueva forma de importar axios completo

const initialState = {
  isLoading: true,
  isError: false,
  data: [],
};

const dataFetchReducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_INIT':
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case 'FETCH_SUCCESS':
      return {
        ...state,
        isLoading: false,
        isError: false,
        data: action.payload,
      };
    case 'FETCH_FAILURE':
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    case 'FETCH_EMPTY':
      return {
        ...state,
        isLoading: false,
        isError: false,
      };
    default:
      throw new Error();
  }
};

export const APIRequest = (initialUrl) => {
  const [url, setUrl] = useState(initialUrl);

  const [state, dispatch] = useReducer(dataFetchReducer, initialState);

  useEffect(() => {
    let didCancel = false;

    const fetchData = async () => {
      dispatch({ type: 'FETCH_INIT' });

      try {
        // const result = await get(process.env.REACT_APP_API_URL + url); // ❌ Línea antigua que usaba 'get' directamente
        const result = await axios.get(process.env.REACT_APP_API_URL + url); // ✅ Ahora usamos axios.get correctamente

        if (!didCancel) {
          if (result.status === 204) {
            dispatch({ type: 'FETCH_EMPTY' });
          } else {
            dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
          }
        }
      } catch (error) {
        if (!didCancel) {
          dispatch({ type: 'FETCH_FAILURE' });
        }
      }
    };

    fetchData();

    return () => {
      didCancel = true;
    };
  }, [url]);

  return [state, setUrl];
};